/**
 * Fills the delivery estimate's country flag in the cart trust row.
 *
 * Liquid can't build a flag emoji (it needs regional-indicator codepoint
 * maths), so it ships the ISO code in a data attribute and this fills it in.
 *
 * The cart summary is replaced by the Section Rendering API on every cart
 * change, and the replacement lands at a point that neither the
 * shopify:cart:lines-update event nor its promise reliably brackets — so this
 * watches the DOM instead of trying to predict the timing.
 */
const flagFor = (code) =>
  [...code.toUpperCase()].map((char) => String.fromCodePoint(127397 + char.charCodeAt(0))).join('');

const render = () => {
  for (const el of document.querySelectorAll('[data-country-flag]')) {
    const code = el.dataset.countryFlag;
    if (code && !el.textContent) el.textContent = flagFor(code);
  }
};

render();

new MutationObserver(render).observe(document.documentElement, { childList: true, subtree: true });
